<template>
  <StatisticsItem
    class="statistics-candidates"
    :title="$t('generics.sourcing-cap')"
    :steps="steps"
  />
</template>

<script setup lang="ts">
import StatisticsItem from './StatisticsItem.vue';
import { useStatisticsStore } from '@/store/pinia/statistics';
import { computed } from 'vue';
import { useI18n } from '@/i18n/i18n';

const statisticsStore = useStatisticsStore();
const { t } = useI18n();


const steps = computed(() => [
  {
    key: 'candidate-contacts',
    name: t('statistics.nb-candidate-contacts'),
    icon: 'presentation',
    value: statisticsStore?.statistics?.contactedCandidates?.value || 0,
    total: statisticsStore?.statistics?.contactedCandidates?.total || 0,
    topPerformers: statisticsStore?.statistics?.contactedCandidates?.topPerformers || [],
    isLoading: statisticsStore?.statistics?.contactedCandidates?.isLoading || false,
  },
  {
    key: 'candidate-qualifications',
    name: t('statistics.nb-candidate-notation'),
    icon: 'star',
    value: statisticsStore?.statistics?.candidatesQualifications?.value || 0,
    total: statisticsStore?.statistics?.candidatesQualifications?.total || 0,
    topPerformers: statisticsStore?.statistics?.candidatesQualifications?.topPerformers || [],
    isLoading: statisticsStore?.statistics?.candidatesQualifications?.isLoading || false,
  },
]);
</script>
